<app-page-title title="Frequência"></app-page-title>

<div class="form-container">
  <div class="infos">
    <p class="title">Tema do estudo</p>
    <p class="value">{{ groupWord?.theme }}</p>
    <p class="title">Célula</p>
    <p class="value">{{ group?.name }}</p>
  </div>
  <form [formGroup]="form">
    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Data</mat-label>
      <input type="date" class="input" matInput formControlName="date" />
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Horario</mat-label>
      <input type="time" class="input" matInput formControlName="hour" />
    </mat-form-field>

    <form [formGroup]="frequencyUsers" *ngIf="frequencyUsers" class="member-list">
      <mat-list role="list">
        <mat-list-item *ngFor="let member of members" class="member-item">
          <input type="checkbox" id="scales" name="scales" checked [formControlName]="[member.id]" />
          {{ member.name }}
        </mat-list-item>
      </mat-list>
    </form>
    <h3>VIsitantes</h3>
    <br />
    <ng-container formArrayName="visitors">
      <ng-container *ngFor="let visitor of visitors?.controls; let i = index">
        <div class="lesson-form-row" [formGroup]="visitor">
          <mat-form-field class="example-full-width" appearance="outline">
            <input matInput formControlName="name" placeholder="nome" />
          </mat-form-field>
          <img src="../../../assets/icons/delete.svg" sizes="10" (click)="deleteVisitor(i)" />
        </div>
      </ng-container>
    </ng-container>
    <div>
      <button color="primary" aria-label="Example icon button with a delete icon" (click)="addVisitor()">
        + visitante
      </button>
    </div>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Observação</mat-label>
      <textarea class="input" matInput formControlName="obs"></textarea>
    </mat-form-field>

    <button (click)="save()" class="btn-primary" mat-raised-button>Salvar</button>
  </form>
</div>
